import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Button } from '../../../../Controls/Button/index.js';
import Icons from '../../../../Elements/Icons/index.js';
/**
 * The prev/next page buttons shared by `Table.Info` and `Table.Pagination`. Next is disabled on the
 * last page and when `total === 0` (the latter matters while loading with no data, where the caller
 * still renders the controls). The bound uses `>=` (not `===`) so an out-of-range page — e.g. after
 * `total` shrinks, which usePageInfo clamps for display — keeps Next disabled instead of pushing the
 * page further out of range.
 */
export const PaginationControls = memo(function PaginationControls({ page, perPage, total, onPrev, onNext, prevDataTestId = 'backward-button', nextDataTestId = 'forward-button', }) {
    const isLastPage = total === 0 || page >= Math.ceil(total / perPage) - 1;
    return (_jsxs(_Fragment, { children: [_jsx(Button, { secondary: true, iconOnly: true, onClick: onPrev, disabled: page === 0, dataTestId: prevDataTestId, children: _jsx(Icons.Arrow, { align: 'left' }) }), _jsx(Button, { secondary: true, iconOnly: true, onClick: onNext, disabled: isLastPage, dataTestId: nextDataTestId, children: _jsx(Icons.Arrow, { align: 'right' }) })] }));
});
